/**
 * @author EdenCha <eden@nurigo.net>
 */
import React from 'react'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import withStyles from '@material-ui/core/styles/withStyles'
import SearchSelectField from 'components/atoms/SearchSelectField'
import SearchDateField from 'components/atoms/SearchDateField'
import SearchTextField from 'components/atoms/SearchTextField'
import SearchCheckboxField from 'components/atoms/SearchCheckboxField'

import DatePickerInputContainer from 'containers/DatePickerInputContainer'

import moment from 'moment-timezone'

const styles = theme => ({
  root: {}
})
export const useProps = [
  'type',
  'label',
  'value',
  'color',
  'minDate',
  'maxDate',
  'itemIndex',
  'selectValue',
  'simpleFormDateRange',
  'condition',
  'dateFormat',
  'disableEnter',
  'onSubmitSearch',
  'onChangeSearchValue'
]
const SearchSimpleFields = ({ classes, proxy, ...props }) => {
  const {
    width,
    type,
    label,
    value,
    color,
    multiple,
    renderValue,
    minDate,
    maxDate,
    itemIndex,
    selectValue,
    simpleFormDateRange,
    criteria,
    condition,
    dateFormat,
    disableEnter,
    datePickerProps = {},
    onSubmitSearch,
    onChangeSearchValue,
    // startDate, endDate 등으로 나뉜경우
    onChangeDateRange,
    // 단일 항목에 대해서 날짜선택의 경우
    onChangeDatePicker
  } = props
  return (
    <React.Fragment>
      {type === 'select' && (
        <SearchSelectField
          {...{
            label,
            value,
            multiple,
            renderValue,
            criteria,
            itemIndex,
            selectValue,
            onChangeSearchValue
          }}
        />
      )}
      {type === 'datePicker' && (
        <DatePickerInputContainer
          onComplete={selectedDate =>
            onChangeDatePicker(itemIndex, selectedDate)
          }
          DatePickerProps={{
            ...datePickerProps,
            selectedDate: (value || [])
              .filter(d => d)
              .map(d => moment(d).format('YYYYMMDD'))
          }}
          TextFieldProps={{
            label,
            fullWidth: true,
            placeholder: 'YYYY.MM.DD ~ YYYY.MM.DD',
            style: { minWidth: 200 },
            InputLabelProps: { shrink: true }
          }}
        />
      )}
      {type === 'rangeDate' && (
        <DatePickerInputContainer
          onComplete={selectedDate =>
            onChangeDateRange(itemIndex, selectedDate)
          }
          DatePickerProps={{
            ...datePickerProps,
            selectedDate: value.split(',').filter(d => d)
          }}
          TextFieldProps={{
            label,
            fullWidth: true,
            placeholder: 'YYYY.MM.DD ~ YYYY.MM.DD',
            style: { minWidth: 200 },
            InputLabelProps: { shrink: true }
          }}
        />
      )}
      {(type === 'date' || type === 'datetime') && (
        <SearchDateField
          {...{
            type,
            label,
            value,
            criteria,
            itemIndex,
            minDate,
            maxDate,
            simpleFormDateRange,
            condition,
            dateFormat,
            disableEnter,
            onSubmitSearch,
            onChangeSearchValue
          }}
        />
      )}
      {(type === 'text' || type === 'number') && (
        <SearchTextField
          {...{
            type,
            label,
            value,
            criteria,
            itemIndex,
            onChangeSearchValue,
            onSubmitSearch
          }}
        />
      )}
      {type === 'checkbox' && (
        <SearchCheckboxField
          {...{ label, value, color, criteria, itemIndex, onChangeSearchValue }}
        />
      )}
    </React.Fragment>
  )
}
export default withWidth()(withStyles(styles)(SearchSimpleFields))
